import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
// initial state
export const initialState = {
  notesLoader: false,
  error: null,
  success: false,
  notes: [],
  category: [],
  users: [],
  notifications: [],
};
const createNoteHierarchy = (notes) => {
  const noteMap = {};
  const threadRootMap = {};
  // Create a map of notes using noteID as keys

  notes.forEach((note) => {
    noteMap[note.noteID] = note;
    note.childNotes = [];
    if (note.parentNoteID === 0) {
      threadRootMap[note.threadID] = note;
    }
  });

  // Build the hierarchy by attaching child notes to their respective threads
  notes.forEach((note) => {
    if (note.parentNoteID !== 0) {
      const rootNote = threadRootMap[note.threadID];
      if (rootNote) {
        rootNote.childNotes.push(note);
      }
    }
  });

  return Object.values(threadRootMap);
};
const extractUsers = (notes) => {
  const allUsers = [];

  notes.forEach((note) => {
    if (!allUsers.includes(note.userName)) {
      allUsers.push(note.userName);
    }
  });

  return allUsers;
};
// our slice
const notesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.notesLoader = true;
    },
    setError: (state, { payload }) => {
      state.notesLoader = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.notesLoader = false;
      state.error = false;
      state.success = true;
    },
    setCategoryDetails: (state, { payload }) => {
      if (payload) {
        state.category = payload;
      }
    },
    setNotesDetails: (state, { payload }) => {
      const allNotes = [...payload];
      const noteHierarchy = createNoteHierarchy(allNotes);
      const allUsers = extractUsers(allNotes);
      if (allUsers) {
        state.users = allUsers;
      }
      if (noteHierarchy) {
        state.notes = noteHierarchy;
      }
    },
    setNotesNotifications: (state, { payload }) => {
      if (payload) {
        state.notifications = payload;
      }
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setCategoryDetails,
  setNotesDetails,
  setNotesNotifications,
} = notesSlice.actions;

export const notesSliceSelector = (state) => state.notes;

export const getCategoryDetails = (userID) => async (dispatch) => {
  try {
    // dispatch(setLoading());
    let req = {
      userID,
    };

    const results = await http
      .post("Order/GetStandardNotesCategory", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(
        setCategoryDetails(
          results.data.responseObject?.getStandardNoteResponseList
        )
      );
      //   dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const GetAllNotes = (FileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      fileId: FileID,
    };

    const results = await http
      .post("Order/GetAllNotesForFile", request)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setNotesDetails(results.data.responseObject?.notes));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
export const saveNote =
  (fileId, note, UserID, parentNoteId, threadID, platform, isPublic, isClientNote) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        fileId: fileId,
        noteBaseText: parentNoteId ? note : note.description,
        noteCustomText: "",
        isImportant: false,
        isPublic: (isPublic !== undefined && isPublic !== null) ? isPublic : true,
        standardNoteId: 0,
        parentNoteID: parentNoteId || null,
        userID: UserID,
        reason: "",
        threadID: threadID || null,
        ExtraInfo: "",
        isEmailSent: null,
        SubmittedPlatform: platform || "CTIC",
        NoteDetails: "",
        IsClientNote: !isClientNote ? false : isClientNote
      };
      let req = { UserID, RequestObject: request };

      const results = await http
        .post("Order/SaveNotesForFile", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(GetAllNotes(fileId));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const UpdateNotification =
  (
    fileID,
    notificationID,
    notificationText,
    addedBy,
    readBy,
    userID,
    clearAll
  ) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let request = {
          notificationID,
          fileID,
          notificationTypeID: 1,
          notificationText,
          addedBy,
          platformID: 28,
          isRead: true,
          readBy,
          clearAll,
        };
        let req = { RequestObject: request };

        const results = await http
          .post("Order/UpdateNotification", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          dispatch(GetAllNotificationsForUser(userID));
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const GetAllNotificationsForUser = (UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());

    let req = { UserID };

    const results = await http
      .post("Order/GetAllNotificationsForUser", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(
        setNotesNotifications(results.data.responseObject.notifications)
      );
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

// export the default reducer
export default notesSlice.reducer;
